import { PageViewDevice } from '@utils/gtm-tracking/events/trackPageViewEvent';

export const deviceTracking = (data: any): PageViewDevice => {
    const { isMobile, isMobileLarge, isTablet, isTabletOrSmaller } = data;

    if (isMobile || isMobileLarge) {
        return 'mobile';
    }

    if (isTablet || isTabletOrSmaller) {
        return 'tablet';
    }

    return 'desktop';
};
